import React, { Component } from 'react'
import { ChromePicker } from 'react-color'
import cx from 'classnames'
import onClickOutside from 'react-onclickoutside-decorator'

import Input from 'shared-web/src/components/Input'

import style from './style.styl'

const Picker = onClickOutside(({ onClickOutside, ...rest }) => <ChromePicker {...rest}/>)

export default class ColorInput extends Component {
  state = {
    showPicker: false,
  }

  static defaultProps = {
    color: '2d88f3',
    valid: true
  }

  static propTypes = {
    color: React.PropTypes.string,
    onChange: React.PropTypes.func,
    valid: React.PropTypes.bool
  }

  changeColor(hex) {
    const { onChange } = this.props
    const fixedHex = hex.replace('#', '')
    onChange && onChange(fixedHex)
  }

  handleHexChange = (event) => this.changeColor(event.target.value)

  handleColorPickerChange = ({ hex }) => this.changeColor(hex)

  handlePaletteClick = () => {
    this.setState({ showPicker: !this.state.showPicker })
  }

  render() {
    const { color, onChange, valid, ...rest } = this.props
    const { showPicker } = this.state
    const extraClassNames = {
      white: color.toLowerCase() === 'ffffff',
      invalid: !valid,
    }
    return (
      <div className={cx(style['color-input'], this.props.size, extraClassNames)}>
        <Input
          {...rest}
          isValid={valid}
          value={color}
          onChange={this.handleHexChange}
          childrenFirst
        >
          <div
            className="palette"
            style={{ backgroundColor: `#${color}` }}
            onClick={this.handlePaletteClick}
          />
          {showPicker &&
            <Picker
              color={color}
              onChangeComplete={this.handleColorPickerChange}
              disableAlpha
              onClickOutside={this.handlePaletteClick}
            />
          }
          <span className={cx('color-input-hash', this.props.size)}>#</span>
        </Input>
        {!valid && <div className="color-input-error">Invalid Hex</div>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/ColorInput/index.js